import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";

// -- redux
import { connect } from "react-redux";
import { Otp } from "../../Redux/Actions/OtpAction";
import { ForgotPassword } from "../../Redux/Actions/ForgotPasswordAction";
import Loader from "../Loader";

function OtpPage(props) {
  const [otp, setOtp] = useState("");
  const [response, setResponse] = useState("");
  const [hide, setHide] = useState(false);
  const [resend, setResend] = useState(false);
  const [seconds, setSeconds] = useState(30);
  const [minutes, setMinutes] = useState(0);

  const submit = (e) => {
    e.preventDefault();
    if (otp) {
      const data = {
        email: props.location.state.email,
        bankcode: props.location.state.bankCode,
        otp: otp,
      };
      props.Otp(data);
      setHide(true);
      setOtp("");
      setTimeout(function () {
        setResponse("");
        setHide(false);
      }, 3000);
    }
  };

  const updateTime = () => {
    if (minutes === 0 && seconds === 1) {
      // setSeconds(0);
      // setMinutes(5);
      setResend(true);
    } else {
      if (seconds === 0) {
        setMinutes((minutes) => minutes - 1);
        setSeconds(30);
      } else {
        setSeconds((seconds) => seconds - 1);
      }
    }
  };

  const resendOtp = () => {
    setResend(false);
    setSeconds(30);
    setMinutes(0);
    setHide(true);
    const data = {
      email: props.location.state.email,
    };
    props.ForgotPassword(data);
  };

  useEffect(() => {
    const token = setTimeout(updateTime, 1000);
    return function cleanUp() {
      clearTimeout(token);
    };
  });

  useEffect(() => {
    if (props.data.error) {
      alert(props.data.data);
    } else {
      props.data && props.data.message && hide && setResponse(props.data.message);
      if (props.forget_data && props.forget_data.message && hide) {
        setTimeout(function () {
          setResponse("");
          setHide(false);
        }, 3000);
        setResponse(props.forget_data.message);
      }
    }
  }, [props]);

  useEffect(() => {
    props.data &&
      props.data.status === 200 &&
      props.history.push({
        pathname: "/create-password",
        token: props.data.data.temp_token,
        email: props.location.state.email,
        bankcode: props.location.state.bankCode,
      });
  }, [props.data]);

  return (
    <>
      {props.loading && <Loader />}
      <p className="f-14 text-center text-white font-weight-normal mb-0">{props && props.location && props.location.state && props.location.state.email}</p>
      <form onSubmit={(e) => submit(e)}>
        <div className="mt-3 text-left">
          <label className="text-white w-100 mb-0" htmlFor="otp">
            <p className="mb-0 f-12">Enter OTP</p>
            <input id="otp" type="text" placeholder="Six digit OTP" className="form-input f-14 mt-1 pb-1 text-white" onChange={(e) => setOtp(e.target.value)} value={otp} autoComplete="off" />
          </label>
        </div>
        {response && <p className="m-0 f-12 text-left text-danger mt-2">{response}</p>}
        <button onClick={(e) => submit(e)} type="submit" className="form-button f-14 mt-5 centerMargin" disabled={!otp}>
          continue
        </button>
        <p className="mt-5 text-white f-12 centerMargin">
          Didn’t receive an OTP?{" "}
          {resend ? (
            <b onClick={() => resendOtp()} className="text-green cursor-pointer">
              Resend OTP
            </b>
          ) : (
            <b>
              {"0" + minutes}:{seconds < 10 && seconds !== 0 ? "0" + seconds : seconds}
            </b>
          )}
        </p>
      </form>
    </>
  );
}

const mapStateToProps = ({ OtpReducer, ForgotPasswordReducer }) => {
  const { loading, data } = OtpReducer;
  const { forget_data } = ForgotPasswordReducer;
  return { loading, data, forget_data };
};

const mapDispatchToProps = {
  Otp,
  ForgotPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OtpPage));
